import '../css/app.css';

import LazyLoad from "vanilla-lazyload";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

var lazyLoadInstance = new LazyLoad({
    //
});

document.addEventListener('DOMContentLoaded', function () {
    const splideElements = document.querySelectorAll('.splide:not([data-lightbox-slider])');
    splideElements.forEach(function (el) {
        const defaults = {
            type: 'fade',
            rewind: true,
            autoplay: true,
            interval: 5000,
            pauseOnHover: false,
            arrows: true,
            pagination: true,
        };
        const dataOptions = el.dataset.splide ? JSON.parse(el.dataset.splide) : {};
        // If perPage > 1, don't use fade type
        if (dataOptions.perPage && dataOptions.perPage > 1) {
            defaults.type = 'slide';
        }
        const options = { ...defaults, ...dataOptions };
        // Honor an explicit pagination:false (e.g. the home hero) so the
        // overflow handler below never re-enables it.
        const wantPagination = options.pagination !== false;
        const splide = new Splide(el, options);
        // When all slides fit (e.g. 3 slides at perPage:3 on desktop), turn off
        // navigation and drag so there's no awkward dead drag. Splide re-fires
        // this on resize, so it re-enables at breakpoints where slides overflow.
        splide.on('overflow', function (overflow) {
            splide.options = {
                arrows: overflow,
                pagination: overflow && wantPagination,
                drag: overflow,
            };
        });
        splide.mount();
    });

    // Lightbox galleries — click a carousel image to open a fullscreen gallery
    document.querySelectorAll('.splide[data-lightbox]').forEach(function (carousel) {
        const lightbox = document.getElementById(carousel.dataset.lightbox);
        if (!lightbox) return;

        let main = null;
        let mounted = false;

        function open(index) {
            lightbox.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');

            if (!mounted) {
                main = new Splide(lightbox.querySelector('.lightbox-main'), {
                    type: 'fade',
                    rewind: true,
                    pagination: false,
                    arrows: true,
                });
                const thumbs = new Splide(lightbox.querySelector('.lightbox-thumbs'), {
                    fixedWidth: 100,
                    fixedHeight: 64,
                    gap: 8,
                    rewind: true,
                    pagination: false,
                    arrows: false,
                    isNavigation: true,
                    focus: 'center',
                });
                main.sync(thumbs);
                main.mount();
                thumbs.mount();
                mounted = true;
            }

            main.go(index);
            main.refresh();
        }

        function close() {
            lightbox.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        }

        carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone) img').forEach(function (img, index) {
            img.addEventListener('click', function () {
                open(index);
            });
        });

        lightbox.querySelector('.lightbox__close').addEventListener('click', close);

        lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) close();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) close();
        });
    });

    // Booking CTAs — open the DeltaHQ drawer in place when its loader is
    // ready; otherwise fall through to the href (anchor to the filter bar).
    // The drawer is property-scoped: without an id its iframe stays empty, so
    // triggers may carry data-booking-property, and everything else falls back
    // to the company's first property from the same API the filter bar uses.
    let bookingPropertyId = null;

    function defaultBookingProperty() {
        if (bookingPropertyId) return Promise.resolve(bookingPropertyId);
        const script = document.querySelector('script[src*="deltaBookingLoader"]');
        if (!script) return Promise.resolve(null);
        const apiRoot = (script.getAttribute('api-src') || '').replace(/\/+$/, '');
        return fetch(apiRoot + '/v2/direct-booking/search-options?target=iframe', {
            headers: {
                'X-Delta-DBK-API-Key': script.getAttribute('data-company-api-key') || '',
                'locale': 'en',
                'tenant': 'host',
            },
        })
            .then(function (res) { return res.json(); })
            .then(function (json) {
                const properties = (json.data || {}).properties || [];
                bookingPropertyId = properties.length ? properties[0].id : null;
                return bookingPropertyId;
            })
            .catch(function () { return null; });
    }

    if (document.querySelector('[data-booking-open]')) {
        defaultBookingProperty();
    }

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-booking-open]');
        if (!trigger || !window.DeltaBooking) return;
        e.preventDefault();
        const explicit = trigger.getAttribute('data-booking-property');
        if (explicit) {
            window.DeltaBooking.setSrcParams({ id: explicit });
            return;
        }
        defaultBookingProperty().then(function (id) {
            if (id != null) {
                window.DeltaBooking.setSrcParams({ id: id });
            } else {
                window.DeltaBooking.open();
            }
        });
    });

    // Mobile menu toggle
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const mainNav = document.getElementById('main-nav');
    const menuIconOpen = document.getElementById('menu-icon-open');
    const menuIconClose = document.getElementById('menu-icon-close');

    if (mobileMenuToggle && mainNav) {
        mobileMenuToggle.addEventListener('click', function () {
            mainNav.classList.toggle('hidden');
            mainNav.classList.toggle('flex');
            menuIconOpen.classList.toggle('hidden');
            menuIconClose.classList.toggle('hidden');
            document.body.classList.toggle('overflow-hidden');
        });
    }

    const newsletterForm = document.getElementById('newsletter-form');
    if (newsletterForm) {
        const messageEl = document.getElementById('newsletter-message');
        const submitBtn = document.getElementById('newsletter-submit');
        const submitLabel = submitBtn.textContent;
        // Translated in _newsletter.twig; the English here is only a last resort.
        const successMessage = messageEl.dataset.successMessage || "Thanks — you're on the list.";
        const errorMessage = messageEl.dataset.errorMessage || 'Something went wrong. Please try again.';

        newsletterForm.addEventListener('submit', async function (e) {
            e.preventDefault();
            messageEl.className = 'mt-3 text-sm hidden';
            submitBtn.disabled = true;
            submitBtn.textContent = '…';

            try {
                const res = await fetch(newsletterForm.action || window.location.href, {
                    method: 'POST',
                    body: new FormData(newsletterForm),
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });
                const data = await res.json();

                if (data.success) {
                    newsletterForm.reset();
                    messageEl.textContent = data.message || successMessage;
                    messageEl.className = 'mt-3 text-sm text-gold';
                } else {
                    const firstError = Object.values(data.errors || {}).flat()[0]
                        || errorMessage;
                    messageEl.textContent = firstError;
                    messageEl.className = 'mt-3 text-sm text-red-300';
                }
            } catch (err) {
                messageEl.textContent = errorMessage;
                messageEl.className = 'mt-3 text-sm text-red-300';
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = submitLabel;
            }
        });
    }
});
